export { getForwardCommunicatorState } from '../_internal/selectors/getForwardCommunicatorState';